import type { Theme, Components } from '@mui/material/styles';

export const components: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: {
      'h1, h2': {
        textTransform: 'capitalize',
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        body3: 'p',
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 12,

        // Mobile
        fontSize: '14px',

        // Desktop (md and above)
        [theme.breakpoints.up('md')]: {
          fontSize: '16px',
        },

        '& .MuiButton-startIcon': {
          marginLeft: 0,
          marginRight: 8,
        },

        '& .MuiButton-endIcon': {
          marginLeft: 8,
          marginRight: 0,
        },
      }),

      sizeLarge: {
        padding: '12px 16px',
      },

      sizeMedium: {
        padding: '10px 20px',
      },

      sizeSmall: {
        padding: '6px 14px',
      },

      contained: ({ theme }) => ({
        '&.Mui-disabled': {
          color: theme.palette.neutralDark.medium,
          backgroundColor: theme.palette.neutralLight.dark,
        },
      }),
    },
  },

  MuiCard: {
    styleOverrides: {
      root: { borderRadius: 12 },
    },
  },

  MuiCardContent: {
    styleOverrides: {
      root: { padding: 16, '&:last-child': { paddingBottom: 16 } },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: { borderRadius: 6, fontWeight: 600, fontSize: '0.75rem' },
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 12,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.neutralLight.darkest,
          borderWidth: '1px',
        },
        '&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.neutralLight.darkest,
        },
        '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.neutralDark.darkest,
          borderWidth: '1.5px',
        },
        '&.Mui-focused:hover:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.neutralDark.darkest,
          borderWidth: '1.5px',
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.support.error.medium,
          borderWidth: '1.5px',
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.neutralLight.light,
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.neutralLight.darkest,
          borderWidth: '1px',
        },
      }),
      input: ({ theme }) => ({
        padding: '0.75rem 1rem',
        '&.Mui-disabled': {
          backgroundColor: theme.palette.neutralLight.light,
          WebkitTextFillColor: theme.palette.neutralDark.lightest,
        },
      }),
    },
  },

  MuiFilledInput: {
    styleOverrides: {
      root: { borderRadius: 8 },
    },
  },

  MuiAppBar: {
    defaultProps: { elevation: 0, color: 'inherit' },
    styleOverrides: {
      root: ({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
      }),
    },
  },

  MuiBottomNavigation: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderTop: `1px solid ${theme.palette.divider}`,
      }),
    },
  },

  MuiDivider: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderColor: theme.palette.divider,
      }),
    },
  },
};
